import { ReactNode } from "react";

interface Props { label: string; value: ReactNode; sub?: ReactNode; icon?: ReactNode; }

export default function AdminStatCard({ label, value, sub, icon }: Props) {
  return (
    <div className="stat">
      <div className="flex items-center justify-between">
        <div className="stat-label">{label}</div>
        {icon}
      </div>
      <div className="stat-value">{value}</div>
      {sub && <div className="text-sm text-steel-300 mt-1">{sub}</div>}
    </div>
  );
}
